import { Button } from "react-bootstrap"

import PendingDrugTest from "../../../api/OrphanedResults/Models/PendingDrugTest"
import ActionButton from "../../ActionButton"

interface PendingDrugTestsButtonsProps {
  selectedTest?: PendingDrugTest
  selectedDonor?: boolean
  disabled?: boolean
  acceptSpin?: boolean
  createNewSpin?: boolean
  onCancel: () => void
  onCreateNew: () => void
  onAccept: () => void
}

function PendingDrugTestsButtons({
  selectedTest = undefined,
  selectedDonor = false,
  disabled = false,
  acceptSpin = false,
  createNewSpin = false,
  onCancel,
  onCreateNew,
  onAccept,
}: PendingDrugTestsButtonsProps) {
  return (
    <>
      <Button variant="primary" onClick={onCancel}>
        Cancel
      </Button>
      <ActionButton
        variant="secondary"
        onClick={onCreateNew}
        disabled={!!selectedTest || disabled || !!selectedDonor}
        spin={createNewSpin}
      >
        Create New
      </ActionButton>
      <ActionButton
        variant="secondary"
        onClick={onAccept}
        disabled={(!selectedTest && !selectedDonor) || disabled}
        spin={acceptSpin}
      >
        Accept
      </ActionButton>
    </>
  )
}

export default PendingDrugTestsButtons
